var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card_container"},[_c('a-avatar',{staticClass:"text-capitalize profile_avatar",style:({
      color: ' #ffffff !important',
      'background-color': _vm.people.url ? '' : _vm.getAvatarColor(_vm.people.id)
    }),attrs:{"size":70,"src":_vm.people.url,"alt":"profile"},on:{"click":function($event){return _vm.viewProfile(_vm.people)}}},[_vm._v("\n    "+_vm._s(_vm.people.firstName
        ? _vm.people.firstName[0]
        : _vm.people.display_name
        ? _vm.people.display_name[0]
        : _vm.people.first_name[0])+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"right_items"},[_c('div',{staticClass:"d-inline-block text-left ml-2 align-self-center overflow-hidden",staticStyle:{"flex":"1"}},[_c('p',{staticClass:"bold-text cp",style:({
          color: '#0F1734',
          'font-weight': '700',
          'font-size': '20px',
          'line-height': '30px',
          'margin-bottom': '4.5px'
        }),on:{"click":function($event){return _vm.viewProfile(_vm.people)}}},[_vm._v("\n        "+_vm._s(_vm.people.display_name)+"\n      ")]),_vm._v(" "),(_vm.people.location && _vm.people.location[0].state)?_c('p',{staticClass:"m-0 doc-loc",style:({
          color: '#94A3B8',
          'font-weight': '700',
          'font-size': '14px',
          'line-height': '21px'
        })},[_c('img',{style:({
            marginBottom: '3px',
            paddingRight: '6.5px'
          }),attrs:{"src":require("../../assets/images/addphy-location.png"),"alt":"location icon"}}),_vm._v("\n        "+_vm._s(_vm.people.location[0].city)+",\n        "+_vm._s(_vm.people.location[0].state)+"\n      ")]):_vm._e(),_vm._v(" "),_c('p',{style:({
          color: '#0F1734',
          'font-size': '14px',
          'line-height': '21px',
          'font-weight': 'bold',
          'margin-top': '4.5px'
        })},[_vm._v("\n        "+_vm._s(_vm.people.circle_member)+" circle members\n      ")]),_vm._v(" "),_c('a-button',{staticClass:"font-white primary-button profile-btn profile_button_mobile",staticStyle:{"flex":"1"},style:({
          background: _vm.getPrimaryColor()
        }),attrs:{"loading":_vm.loadingbtn === _vm.people.id && _vm.loadingrole === _vm.people.role},on:{"click":function($event){return _vm.viewProfile(_vm.people)}}},[_vm._v("\n        View Profile\n      ")])],1),_vm._v(" "),_c('a-button',{staticClass:"font-white primary-button profile-btn profile_button",style:({
        background: _vm.getPrimaryColor()
      }),attrs:{"loading":_vm.loadingbtn === _vm.people.id && _vm.loadingrole === _vm.people.role},on:{"click":function($event){return _vm.viewProfile(_vm.people)}}},[_vm._v("\n      View Profile\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a610f8ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/AdvocateCard.vue
// module id = null
// module chunks = 